import { FC } from "react";
import styled from "styled-components";
import { ContinentButton } from "./ContinentButtons";
import { Continent } from "components/pages/GlobalRewards/constants";
import { tablet } from "components/templates/Breakpoints";

interface ContinentBarProps {
  selectedContinent: string | null;
  onContinentClick: (continent: string) => void;
}

export const CONTINENTS = [
  Continent.WorldMap,
  Continent.Europe,
  Continent.NorthAmerica,
  Continent.SouthAmerica,
  Continent.Asia,
  Continent.Africa,
  Continent.Oceania,
];

export const ContinentBar: FC<ContinentBarProps> = ({ selectedContinent, onContinentClick }) => {
  return (
    <TabWrap>
      {CONTINENTS.map((continent, index) => (
        <ContinentButton
          key={continent}
          continent={continent}
          isSelected={selectedContinent === continent}
          onClick={() => onContinentClick(continent)}
          index={index}
        />
      ))}
    </TabWrap>
  );
};
const TabWrap = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  position: absolute;
  bottom: 0;
  z-index: 2;
  padding: 1.5rem;

  ${tablet} {
    padding: 1rem;
  }
`;
